const languageFormatEfigs = (copyData) => [
    {
        url: copyData.learn_spanish_url,
        title: copyData.learn_spanish,
        small: copyData.latin_america
    },
    {
        url: copyData.learn_french_url,
        title: copyData.learn_french,
        small: ""
    },
    {
        url: copyData.learn_italian_url,
        title: copyData.learn_italian,
        small: ""
    },
    {
        url: copyData.learn_german_url,
        title: copyData.learn_german,
        small: ""
    },
    {
        url: copyData.learn_english_url,
        title: copyData.learn_english,
        small: copyData.american
    }
];

const languageFormatOther = (copyData) => {
    const languageList = [];
    if (copyData.learn_arabic_url && copyData.arabic) {
        languageList.push({
            url: copyData.learn_arabic_url,
            title: copyData.arabic,
            small: ""
        });
    }
    if (copyData.learn_chinese_url && copyData.learn_chinese) {
        languageList.push({
            url: copyData.learn_chinese_url,
            title: copyData.learn_chinese,
            small: copyData.madarin
        });
    }
    if (copyData.learn_dutch_url && copyData.dutch) {
        languageList.push({
            url: copyData.learn_dutch_url,
            title: copyData.dutch,
            small: ""
        });
    }
    if (copyData.learn_english_british_url && copyData.english) {
        languageList.push({
            url: copyData.learn_english_british_url,
            title: copyData.english,
            small: copyData.british
        });
    }
    if (copyData.learn_tagalog_url && copyData.filipino) {
        languageList.push({
            url: copyData.learn_tagalog_url,
            title: copyData.filipino,
            small: copyData.tagalog
        });
    }
    if (copyData.learn_greek_url && copyData.greek) {
        languageList.push({
            url: copyData.learn_greek_url,
            title: copyData.greek,
            small: ""
        });
    }
    if (copyData.learn_hebrew_url && copyData.hebrew) {
        languageList.push({
            url: copyData.learn_hebrew_url,
            title: copyData.hebrew,
            small: ""
        });
    }
    if (copyData.learn_hindi_url && copyData.hindi) {
        languageList.push({
            url: copyData.learn_hindi_url,
            title: copyData.hindi,
            small: ""
        });
    }
    if (copyData.learn_irish_url && copyData.irish) {
        languageList.push({
            url: copyData.learn_irish_url,
            title: copyData.irish,
            small: ""
        });
    }
    if (copyData.learn_japanese_url && copyData.japanese) {
        languageList.push({
            url: copyData.learn_japanese_url,
            title: copyData.japanese,
            small: ""
        });
    }
    if (copyData.learn_korean_url && copyData.korean) {
        languageList.push({
            url: copyData.learn_korean_url,
            title: copyData.korean,
            small: ""
        });
    }
    if (copyData.learn_latin_url && copyData.latin) {
        languageList.push({
            url: copyData.learn_latin_url,
            title: copyData.latin,
            small: ""
        });
    }
    if (copyData.learn_persian_url && copyData.persian) {
        languageList.push({
            url: copyData.learn_persian_url,
            title: copyData.persian,
            small: copyData.farsi
        });
    }
    if (copyData.learn_polish_url && copyData.polish) {
        languageList.push({
            url: copyData.learn_polish_url,
            title: copyData.polish,
            small: ""
        });
    }
    if (copyData.learn_portuguese_url && copyData.portuguese) {
        languageList.push({
            url: copyData.learn_portuguese_url,
            title: copyData.portuguese,
            small: copyData.brazil
        });
    }
    if (copyData.learn_russian_url && copyData.russian) {
        languageList.push({
            url: copyData.learn_russian_url,
            title: copyData.russian,
            small: ""
        });
    }
    if (copyData.learn_spanish_spain_url && copyData.spanish) {
        languageList.push({
            url: copyData.learn_spanish_spain_url,
            title: copyData.spanish,
            small: copyData.spain
        });
    }
    if (copyData.learn_swedish_url && copyData.swedish) {
        languageList.push({
            url: copyData.learn_swedish_url,
            title: copyData.swedish,
            small: ""
        });
    }
    if (copyData.learn_turkish_url && copyData.turkish) {
        languageList.push({
            url: copyData.learn_turkish_url,
            title: copyData.turkish,
            small: ""
        });
    }
    if (copyData.learn_vietnamese_url && copyData.vietnamese) {
        languageList.push({
            url: copyData.learn_vietnamese_url,
            title: copyData.vietnamese,
            small: ""
        });
    }

    return languageList;
};

const languageFormatMobile = (copyData) => {
    const efigs = languageFormatEfigs(copyData);
    const other = languageFormatOther(copyData);
    return efigs.concat(other).map((l) => {
        return {
            ...l,
            title: l.title.replace("Learn ", "")
        };
    });
};

module.exports = { languageFormatEfigs, languageFormatOther, languageFormatMobile };
